export default "__VITE_ASSET__Bbs2nDy1__"